@import '../../../scss/use-bootstrap-mixins.scss';
$inactive: #ccc;

.journeyBar {
    display: flex !important;
    border: 1px solid #d9d9d9;
    padding: 0 12px;
    border-radius: 18px;
    justify-content: space-evenly;
    align-items: center;

    @include media-breakpoint-up(lg) {
        border: 0;
        justify-content: center;
        margin: 0 0 60px 0 !important;
    }
}

.mobile {
    display: flex !important;
    @include media-breakpoint-up(lg) {
        display: none !important;
    }
}

.desktop {
    display: none !important;
    @include media-breakpoint-up(lg) {
        display: flex !important;
    }
}

.journeyStep {
    padding: 6px 2px;
    flex-grow: 1;
    text-align: center;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;

    &:hover {
        cursor: pointer !important;
    }

    @include media-breakpoint-up(lg) {
        flex-grow: 0;
        padding: 0 10px;
    }

    .number {
        border: 1px solid #d9d9d9;
        color: #d9d9d9;
        font-weight: 600;
        font-size: 12px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 6px;
        line-height: 18px;

        @include media-breakpoint-up(lg) {
            background-color: #fff;
            border: 1px solid #d9d9d9;
            color: #d9d9d9;
        }
    }

    .label {
        line-height: 22px;
        font-size: 10px;
        font-weight: 600;
        color: #d9d9d9;
        @include media-breakpoint-up(sm) {
            font-size: 12px;
        }
    }

    .current_label {
        color: #000;

        @include media-breakpoint-up(lg) {
            color: $primaryOnBackground;
        }
    }

    .active_label {
        color: $primaryOnBackground;
        opacity: 0.3;
    }

    .current_number {
        color: $primary;
        border: 1px solid $primary;

        @include media-breakpoint-up(lg) {
            color: $textColorOnPrimary;
            background-color: $primary;
        }
    }

    .active_number {
        background-color: $primary;
        border: 1px solid $primary;
        color: $textColorOnPrimary;
        opacity: 0.3;
    }

    .active_number_full_opacity {
        background-color: $primary;
        border: 1px solid $primary;
        color: $textColorOnPrimary;
        opacity: 1;
    }

    .active_label_full_opacity {
        color: $primaryOnBackground;
        opacity: 1;
    }
}
